export enum MilestoneStatusChoices {
  UNKNOWN = "UNKNOWN",
  INCOMPLETE = "INCOMPLETE",
  COMPLETED = "COMPLETED",
  CANCELED = "CANCELED",
  ALWAYS_NORMAL = "ALWAYS_NORMAL",
}
